import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";

const BookmakersReviewWidgetAsyncComponent = AsyncComponent(async () => import('./bookmakers-review-widget' /* webpackChunkName: "bookmakers-review-widget" */ ));

export const BookmakersReviewWidgetAsync = (props) => {
  return <React.Suspense fallback={<div/>}>
    <BookmakersReviewWidgetAsyncComponent {...props}/>
  </React.Suspense>
};
